<template>
  <div class="container">
    <navBar/>
    <div class="mt-5 flex w-full">
      <div class="vx-col flex items-center justify-center flex-col sm:w-full md:w-full  lg:w-1/2 xl:w-1/2 mx-auto text-center">
        <img src="@/assets/images/document/sign-waiting.svg" alt="Success" width="465" class="mx-auto mb-4 max-w-full">
        <h1 class="sm:mx-0 mt-5 mb-10 text-5xl d-theme-heading-color">¡Firmando documentos!</h1>

        <h4 class="sm:mx-0 mx-2 sm:mb-10 font-w-400">
          Puedes cerrar esta página.  Estamos terminando de firmar todos tus documentos.
        </h4>
        <h5 class="sm:mx-0 mx-4 mb-4 sm:mb-10 font-w-400" >
          Esto puede demorar un tiempo, cuando el proceso termine te notificaremos por correo.
        </h5>
        <div class="vx-row" v-if="!isLogged">
          <vs-button size="large" to="/" class="float-left mr-10 mt-5">Iniciar sesión</vs-button>
          <vs-button type="border" size="large" to="register" class="float-rightf mt-5">Registrate gratis</vs-button>
        </div>
        <div class="vx-row" v-if="isLogged">
          <vs-button size="large" to="/" class="mt-5">Regresar al dashboard</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";
import {mapState} from "vuex";

export default {
  components: {
    navBar
  },
  data() {
    return {
      isLogged: false
    }
  },
  computed: {
    ...mapState({
      user: function (state) {
        return state.account.user;
      },
    }),
  },
  created() {
    if (this.user) {
      this.isLogged = true;
    }
  }
}
</script>

<style scoped>

</style>
